module.exports = __webpack_public_path__ + "static/img/grand hi-lai hotel.40e5eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/grand hi-lai hotel.png?20181011
// module id = vGF2
// module chunks = 1